var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bb-modal',{attrs:{"blockScroll":"","customPadding":_vm.customModalPadding},on:{"close":function($event){return _vm.closeModal()}}},[_c('header-user-menu',{attrs:{"user":_vm.user},on:{"close":function($event){return _vm.closeModal()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }